import { styled } from "@mui/material/styles";

export const CircularProgressWrapper = styled("div")(() => ({
  backgroundColor: "var(--designer-bg-color)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  position: "absolute",
  top: 0,
  left: 0,
  bottom: 0,
  right: 0,
  zIndex: 10
}));
